import { Injectable } from '@angular/core';
import { DataService as CoreDataService } from '@barthauer/abc/core/data';
import { AbcConfigService } from '@barthauer/abc/core/configuration';
import { Observable } from 'rxjs';
import { IReport } from '../../models/interfaces.model';
@Injectable({
  providedIn: 'root',
})
export class ReportService {
  public readonly generateReportWebApi: string;
  
  constructor(private coreDataService: CoreDataService,private configService: AbcConfigService,) {
    const currentCongfiguration = configService.getConfiguration();
    this.generateReportWebApi = currentCongfiguration.WebApi.ServiceURLs.GenerateReport;
  }

  public generateReport(report : IReport): Observable<ArrayBuffer> {
    return this.coreDataService.executeWebApiPOSTMethod(this.generateReportWebApi,report);
  }
}
